module.exports = __webpack_public_path__ + "img/instagram-monochrome.07c9f869.svg";